import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Loader from "@/components/loader/Loader.vue";
import AddLifestyleProgramCategoryDialog from "./addLifestyleProgramCategoryDialog/AddLifestyleProgramCategoryDialog.vue";
import * as firebase from "firebase/app";

export default {
  name: "LifestyleProgramsSettings",
  components: {
    ValidationObserver,
    ValidationProvider,
    AddLifestyleProgramCategoryDialog,
    ConfirmDlg,
    Loader
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Name'],
          value: "name",
          sortable: false,
          width:'*'
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Color'],
          value: "color",
          sortable: false,
          width:60
        },
        {
          text: "",
          value: "id",
          sortable: false,
          width:200
        }
      ]
    }
  },
  async created() {
    await this.$store.dispatch("getLifestyleProgramCategories");
  },
  computed: {
    currentFacility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    lifestyleProgramCategories() {
      return this.$store.state.socialClubModule.lifestyleProgramCategories
    }
  },
  methods: {
    editLifestyleProgramCategory(row) {
      this.$refs.addCategoryDialog.open(row);
    },
    async deleteLifestyleProgramCategory(row) {
      const isUsed = await this.isCategoryInUse(row.id) 

      const message = isUsed? 
      this.$i18n.messages[this.$i18n.locale]['LifestyleProgramsSettings.DeleteWithDependencyQuestion']:
      this.$i18n.messages[this.$i18n.locale]['LifestyleProgramsSettings.DeleteQuestion'].replace('[name]', row.name)

      this.$refs.confirmationModal.open(null, message, false)
      .then(response => {
        if (response && response.agree) {
          this.$store.dispatch("deleteLifestyleProgramCategory", row.id);
        }
      });
    },
    addLifestyleProgramCategory() {
      this.$refs.addCategoryDialog.open();
    },
    async isCategoryInUse(lifestyleProgramCategoryId){
      const snap = await firebase
        .firestore()
        .collection("socialClubs")
        .where("facilityId", "==", this.currentFacility.id)
        .where("lifestyleProgramCategoryId", "==", lifestyleProgramCategoryId).get()

        return snap.size > 0
    }
  },

}